var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 10.625H16.875C17.2202 10.625 17.5 10.3452 17.5 10C17.5 9.65482 17.2202 9.375 16.875 9.375H3.125C2.77982 9.375 2.5 9.65482 2.5 10C2.5 10.3452 2.77982 10.625 3.125 10.625Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9911 10L10.8081 15.1831C10.6908 15.3003 10.625 15.4592 10.625 15.625C10.625 15.7908 10.6908 15.9497 10.8081 16.0669C10.9253 16.1842 11.0842 16.25 11.25 16.25C11.4158 16.25 11.5747 16.1842 11.6919 16.0669L17.3169 10.4419C17.561 10.1979 17.561 9.80214 17.3169 9.55806L11.6919 3.93306C11.5747 3.81585 11.4158 3.75 11.25 3.75C11.0842 3.75 10.9253 3.81585 10.8081 3.93306C10.6908 4.05027 10.625 4.20924 10.625 4.375C10.625 4.54076 10.6908 4.69973 10.8081 4.81694L15.9911 10Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.51e6af9570ef2173236af3307a1f005c.svg";
export { ForwardRef as ReactComponent };